/** @module Enums */ /** typedoc */

export enum ReleaseLanguagesEnum {
    en = 'en',
    fr = 'fr',
    de = 'de',
    ar = 'ar',
    'zh-yue' = 'zh-yue',
    ca = 'ca',
    zh = 'zh',
    'zh-hant' = 'zh-hant',
    hr = 'hr',
    cs = 'cs',
    da = 'da',
    nl = 'nl',
    et = 'et',
    fi = 'fi',
    el = 'el',
    he = 'he',
    hu = 'hu',
    is = 'is',
    id = 'id',
    it = 'it',
    ja = 'ja',
    ko = 'ko',
    lo = 'lo',
    lv = 'lv',
    lt = 'lt',
    ms = 'ms',
    no = 'no',
    pl = 'pl',
    pt = 'pt',
    ro = 'ro',
    ru = 'ru',
    sk = 'sk',
    es = 'es',
    sv = 'sv',
    tl = 'tl',
    th = 'th',
    tr = 'tr',
    uk = 'uk',
    vi = 'vi'
}
